import { App, Table } from 'antd';
import ReportToolbar from 'containers/Reports/components/ReportToolbar';
import ReportLayout from 'containers/Reports/layout';
import { getDateRange, getFilterQuery, tableLocale } from 'containers/Reports/utils';
import useIsMobile from 'hooks/useIsMobile';
import React, { useEffect, useMemo, useState } from 'react';
import { getData } from 'utils';
import { captureException } from 'utils/errors';
import withGuard from 'components/withGuard';
import { PERMISSIONS } from 'constants/permissions';
import columns from './columns';
import { fetchExpediteDeliveriesReport } from './requests';

function ExpediteDeliveriesReport() {
  const isMobile = useIsMobile();
  const { message } = App.useApp();
  const [filterData, setFilterData] = useState({
    selected: {
      excludeStates: [],
    },
  });
  const [reportData, setReportData] = useState();
  const [pagination, setPagination] = useState({ current: 1, total: 0, needAPICall: false });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (filterData && pagination.needAPICall) {
      getReportData(pagination.current);
    }
  }, [pagination.current]);

  useEffect(() => {
    if (filterData && filterData.options?.locations) {
      getReportData(1);
    }
  }, [filterData]);

  const getReportData = (page) => {
    setLoading(true);

    fetchExpediteDeliveriesReport({ query: getFilterQuery(filterData), page })
      .then((res) => {
        if (res.status === 'success') {
          setReportData(getData(res)?.results);
          setPagination({ current: page, total: getData(res)?.count, needAPICall: false });
        } else message.error(getData(res)?.title || 'Something went wrong');
        setLoading(false);
      })
      .catch((e) => {
        captureException(e);
        setLoading(false);
      });
  };

  const handlePagination = ({ current, total }) => {
    setPagination({ current, total, needAPICall: true });
  };
  const dateRange = getDateRange({
    range: filterData?.selected?.date?.range,
    separator: '-',
  });

  const tableColumns = useMemo(() => columns(isMobile), [isMobile]);

  return (
    <ReportLayout
      title="Expedite Deliveries"
      description={`Delivery orders charged or fulfilled via Expedite from <b>${dateRange}</b>. Use for auditing and billing reconciliation.`}
      defaultRoute="/console/reports"
    >
      <ReportToolbar
        filterData={{ ...filterData }}
        setFilterData={setFilterData}
        hasExcludeStateFilter
        type="expedite-deliveries"
      />
      <Table
        columns={tableColumns}
        dataSource={reportData}
        locale={tableLocale}
        scroll={{ x: 900 }}
        loading={loading}
        rowKey="id"
        pagination={{
          total: pagination.total,
          showTotal: (total) => `${total} results`,
          size: 'small',
          showSizeChanger: false,
          current: pagination.current,
          defaultPageSize: 100,
        }}
        onChange={handlePagination}
        sticky
      />
    </ReportLayout>
  );
}

export default withGuard(ExpediteDeliveriesReport, [PERMISSIONS.REPORTS], { redirect: true });
